import 'es6-promise/auto';
import axios from 'axios';
import { expose } from 'comlink';

export class Messenger {
  constructor(endpoint, props) {
    Object.assign(this, {
      props,
      endpoint,
    });
  }

  async save(props) {
    console.log(props);
    return { message: 'yerrr' };
  }

  devEmail() {
    return {
      status_code: 0,
      message: 'success',
      payload: {
        funnel_section_id: 106,
        email_address: 'alloffers@mdm5.com',
        profile: {
          StateFull: 'New York',
          GenderFull: 'male',
          DOB: '1970-01-01',
          PhoneCode: '234',
          PhonePrefix: '567',
          PhoneSuffix: '8909',
          VisitIndex: 135,
          email_address: 'alloffers@mdm5.com',
          first_name: 'Biren',
          last_name: 'Test',
          address_1: '20 Jay St Suite 1018',
          city: 'Brooklyn',
          state: 'NY',
          zip_code: '11201',
          gender: 'M',
          birth_month: '01',
          birth_day: '01',
          birth_year: '1970',
          phone_number: '2345678909',
        },
        flow_driver: '3',
        sooper_q: {
          cpa: {
            version: '352.2',
            resultCode: '0',
            resultMessage: 'Succeeded.',
          },
          prepings: {
            version: '352.2',
            resultCode: '0',
            resultMessage: 'Succeeded.',
          },
        },
        offers: { shown: 'success', response: 'success' },
        pixels: [
          '//r.everydaywinner.com/p.ashx?o=141&e=3&t=TRANSACTION_ID&r=507928943',
          '//r.everydaywinner.com/p.ashx?o=40&e=1&t=TRANSACTION_ID&r=507928943',
          '//r.everydaywinner.com/p.ashx?o=37&e=1&fb=1&t=TRANSACTION_ID&r=507928943',
          '//r.everydaywinner.com/p.ashx?o=36&e=3&fb=1&t=TRANSACTION_ID&r=507928943',
          '//r.everydaywinner.com/p.ashx?o=55&e=3&fb=1&t=TRANSACTION_ID&r=507928943',
        ],
        postback: [
          '<?xml version="1.0" encoding="utf-8"?>\r\n<result>\r\n\t<code>1</code>\r\n\t<msg>RECEIVED</msg>\r\n</result>',
          '<?xml version="1.0" encoding="utf-8"?>\r\n<result>\r\n\t<code>1</code>\r\n\t<msg>Duplicate</msg>\r\n</result>',
          '<?xml version="1.0" encoding="utf-8"?>\r\n<result>\r\n\t<code>1</code>\r\n\t<msg>RECEIVED</msg>\r\n</result>',
        ],
        user_id: '359833qpnS',
        visit_id: 'OF7r975122',
      },
    };
  }

  devZip() {
    const data = {
      status_code: 0,
      message: 'success',
      payload: { city: 'Brooklyn', state: 'NY' },
    };

    const { payload } = data;

    Object.assign(data, {
      payload: {
        profile: payload,
      },
    });

    return data;
  }

  devSubmit() {
    return {
      status_code: 0,
      message: 'success',
      payload: {
        funnel_section_id: 107,
        campaigns_served: [
          { VersionID: '222222', CampaignID: '6646', PlacementOrder: 0 },
        ],
        flow_driver: '4',
        campaign_shown: '6646|3',
        campaign_responses: '6646|1',
        entries: { Message: 'Success! Additional Entry Recorded' },
      },
    };
  }

  devSave() {
    return {
      status_code: 0,
      message: 'b846a891-a18b-47e6-9d0e-ae0c18557bfb',
      debug: {
        panel_id: 0,
        panel_name: 'email_address',
        panel_value: 'alloffers@mdm5.com',
        email_address: 'alloffers@mdm5.com',
        cake_id: '507928943',
        user_id: '359833qpnS',
        visit_id: 'Jm05805011',
        funnel_id: 15,
        browser_id: 'c92989e1-5fe8-44bb-a6d4-85659335e766',
        source: 'FlatironTestSweeps66',
        url: 'https://www.everydaywinner.com/?override=15&utm_source=FlatironTestSweeps66&utm_campaign=&utm_medium=66&utm_term=&r=507928943?override=15&utm_source=FlatironTestSweeps66&utm_campaign=&utm_medium=66&utm_term=&r=507928943',
        uri: 'http://104.209.182.213:5001/v1/log/profile/create',
      },
      payload:
        '{"panel_id":0,"panel_name":"email_address","panel_value":"alloffers@mdm5.com","email_address":"alloffers@mdm5.com","cake_id":"507928943","user_id":"359833qpnS","visit_id":"Jm05805011","funnel_id":15,"browser_id":"c92989e1-5fe8-44bb-a6d4-85659335e766","source":"FlatironTestSweeps66","url":"https:\\/\\/www.everydaywinner.com\\/?override=15&utm_source=FlatironTestSweeps66&utm_campaign=&utm_medium=66&utm_term=&r=507928943?override=15&utm_source=FlatironTestSweeps66&utm_campaign=&utm_medium=66&utm_term=&r=507928943","ip_address":"68.95.97.185","user_agent":"Mozilla\\/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit\\/537.36 (KHTML, like Gecko) Chrome\\/112.0.0.0 Safari\\/537.36","browser":"Chrome","browser_version":"112.0.0.0","operating_system":"Windows","operating_system_version":"10.0"}',
    };
  }

  //  const controller = window.sooper_panel.controller,
  //     payload = Object.assign(props, {
  //       email_address: controller.profile.email_address || false,
  //       user_id: controller.user_id || false,
  //     });
  async send(payload) {
    let action = payload?.action ?? false,
      endpoint = this.endpoint;

    if (action) {
      endpoint = `${endpoint}/${action}`;
      delete payload.action;
    }

    if (this.props.browser_id === '487bc10f-16cf-4827-8da4-2a62a0e60195') {
      console.group(endpoint.split('?')[0].split('/').slice(-1)[0]);
      console.log({ ...this.props, ...payload });
      console.groupEnd();
      switch (endpoint.split('?')[0].split('/').slice(-1)[0]) {
        case 'email':
          return this.devEmail();
        case 'save':
          return this.devSave();
        case 'zip':
          return this.devZip();
        case 'submit':
          return this.devSubmit();
      }
    }

    try {
      // const controller = new AbortController();
      const { data } = await axios.post(
        endpoint,
        { ...this.props, ...payload },
        {
          timeout: 1e5,
          // signal: controller.signal.timeout(1e4),
          headers: {
            'Content-Type': 'application/json',
          },
          transformRequest: [
            function (data, headers) {
              return JSON.stringify(data);
            },
          ],
          transformResponse: [
            function (data) {
              return JSON.parse(data);
            },
          ],
        },
      );

      if (
        action &&
        action.split('?')[0] === 'zip' &&
        Object.keys(data.payload).length === 2
      ) {
        const { payload } = data;

        Object.assign(data, {
          payload: {
            profile: payload,
          },
        });
      }

      return data;
    } catch (e) {
      return {
        status_code: -1,
        message: e.message,
      };
    }
  }
}

expose(Messenger);
